import { useEffect, useState } from 'react'
import isNil from 'lodash/isNil'

export function useNonNull<T>(pval?: T | null): T | null {
  const [val, setVal] = useState(pval)

  useEffect(() => {
    if (!isNil(pval)) {
      setTimeout(() => {
        setVal(pval)
      })
    }
  }, [pval])

  return val ?? null
}
